export enum MedicalPrescriptionMappingType {
  ProductCategory = 0,
  TherapeuticClass = 1,
}
